let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5odbj"), load("P2OWY"), load("frTOf")]).then(() => parcelRequire('8taxc'));